// ---------- Rótulo de tamanho do modelo de etiqueta ----------
//
// O nome de um `LabelTemplate` é texto livre digitado pelo usuário (decisão
// owner 2026-06-01). O tamanho da etiqueta deixou de compor o nome: vira um
// rótulo separado, usado nos chips da listagem e no agrupamento do seletor de
// impressão. Função pura, sem i18n. Espelho Kotlin manual em
// `apps/android/.../feature/templates/TemplateName.kt` (duplicação
// intencional — ver CLAUDE.md).

/** Rótulo de tamanho da etiqueta, ex.: `51×25mm`. Espelhado em Kotlin. */
export function templateSizeLabel(widthMm: number, heightMm: number): string {
  return `${String(widthMm)}×${String(heightMm)}mm`;
}
